import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { DashboardDataProvider } from "../../data-provider/dashboard.dp";
import { Dashboard } from "../../models/dashboard.model";
import { PermissionCheck } from "../../shared/permission";
import { UserDataProvider } from "../../data-provider/user.dp";
import { User } from "../../models/user.model";

let CreateDashboardComponent = {
    selector: "vcCreateDashboard",
    templateUrl:
        "/angular/components/dashboard/create-dashboard.component.html",
    bindings: {
        dashboard: "=?",
        duplicate: "=?",
        location: "=",
    },
    controller: class CreateDashboardController {
        // * bindings for typescript compiler *
        public dashboard?: Dashboard;
        public duplicate?: boolean;
        public location?: string;
        // ************************************

        public accessType: string | number;
        public name: string;
        public title: string;
        public mode: string;
        public saving: boolean = false;
        public loading: boolean = true;
        public permissionProvider: PermissionCheck;
        public user: User;
        private dialog: DialogUtils;
        private dataProvider: DashboardDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            DashboardDataProvider: DashboardDataProvider,
            UserDataProvider: UserDataProvider,
            PermissionCheck: PermissionCheck
        ) {
            this.dialog = DialogUtils;
            this.dataProvider = DashboardDataProvider;
            this.permissionProvider = PermissionCheck;
            this.user = UserDataProvider.getActiveUser();
        }

        $onInit() {
            if (!this.dashboard) {
                this.dashboard = new Dashboard();
                this.dashboard.location = this.location;
                this.title = "Create New " + this.dashboard.referenceName();
                this.mode = "create";
            } else {
                if (this.duplicate) {
                    this.dashboard.name = this.dashboard.name + " (duplicate)";
                    this.title = "Duplicate " + this.dashboard.referenceName();
                    this.mode = "duplicate";
                } else {
                    this.title = "Edit " + this.dashboard.referenceName();
                    this.mode = "edit";
                }
            }

            this.permissionProvider.getFeaturePermissions().then(() => {
                if (
                    !this.permissionProvider.hasPermission(
                        "CREATE_PUBLIC_DASHBOARD"
                    )
                ) {
                    this.dashboard.access = "private";
                }
                this.loading = false;
            });
        }

        confirm(): void {
            this.saving = true;
            if (this.dashboard.id) {
                if (this.duplicate) {
                    let data: Dashboard = angular.copy(this.dashboard);
                    this.dataProvider.duplicate(data).then(
                        (dashboard: any): void => {
                            this.dialog.hide(dashboard);
                        },
                        (error: any): void => {
                            console.log(error);
                        }
                    );
                } else {
                    this.dataProvider.update(this.dashboard).then(
                        (dashboard: any): void => {
                            this.dialog.hide(dashboard);
                        },
                        (error: any): void => {
                            this.saving = false;
                            console.log(error);
                        }
                    );
                }
            } else {
                this.dataProvider.create(this.dashboard).then(
                    (dashboard: Dashboard): void => {
                        dashboard.hasEditPermission = true;
                        this.dialog.hide(dashboard);
                    },
                    (error: any): void => {
                        this.saving = false;
                        console.log(error);
                    }
                );
            }
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("dashboard", ["angular-inview"])
    .component(CreateDashboardComponent.selector, CreateDashboardComponent);
